import External from "@/layouts/External";

export default {
  path: "/external",
  component: External,
  children: [
    {
      path: "compliance",
      name: "external.compliance",
      component: () => import("@/views/external/ComplianceExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Compliance",
        targetReadRoute: "external/read-compliance",
      },
    },
    {
      path: "read-compliance/:slug",
      name: "external.readcompliance",
      component: () => import("@/views/external/ReadComplianceExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Ler Compliance",
      },
    },
    {
      path: "compliance/category/:id",
      name: "external.compliancecategory",
      component: () =>
        import("@/views/external/ComplianceCategoryExternal.vue"),
      meta: { requiresLogin: false },
      props: { title: "Categoria Compliance" },
    },
    {
      path: "compliance/subcategory/:id",
      name: "external.compliancesubcategory",
      component: () =>
        import("@/views/external/ComplianceSubcategoryExternal.vue"),
      meta: { requiresLogin: false },
      props: { title: "Subcategoria Compliance" },
    },
    {
      path: "news",
      name: "external.news",
      component: () => import("@/views/external/NewsExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Notícias",
        targetReadRoute: "external/read-news",
      },
    },
    {
      path: "read-news/:slug",
      name: "external.readnews",
      component: () => import("@/views/main/ReadNews.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Ler Notícia",
      },
    },
    {
      path: "articles",
      name: "external.articles",
      component: () => import("@/views/external/ArticlesExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Articles",
        targetReadRoute: "external/read-articles",
      },
    },
    {
      path: "read-articles/:slug",
      name: "external.readarticles",
      component: () => import("@/views/main/ReadArticles.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Ler Artigo",
      },
    },
    {
      path: "privacy-portal",
      name: "external.privacyportal",
      component: () => import("@/views/external/PrivacyPortalExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Portal da Privacidade",
      },
    },
    {
      path: "privacy-portal-category/:id",
      name: "external.privacyportalcategory",
      component: () =>
        import("@/views/external/PrivacyPortalCategoryExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Categoria do Portal da Privacidade ",
      },
    },
    {
      path: "read-privacy-news/:slug",
      name: "external.readprivacyportal",
      component: () => import("@/views/external/ReadPrivacyNews.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Ler Portal da Privacidade",
      },
    },
    {
      path: "privacy-office",
      name: "external.privacyoffice",
      component: () => import("@/views/external/PrivacyOfficeExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Escritório de Privacidade",
      },
    },
    {
      path: "privacy-policy",
      name: "external.privacypolicy",
      component: () => import("@/views/external/PrivacyPolicyExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Política de Privacidade",
      },
    },
    {
      path: "report-incident",
      name: "external.reportincident",
      component: () =>
        import("@/views/external/ReportIncidentFormExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Informar Incidente ou Vazamento de Dados",
      },
    },
    {
      path: "suggestion",
      name: "external.suggestion",
      component: () => import("@/views/external/SuggestionsExternal.vue"),
      meta: { requiresLogin: false },
      props: {
        title: "Suggestion",
      },
    },
  ],
};
